module.exports = __webpack_public_path__ + "static/img/2-role.4e3d235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/2-role.png
// module id = msqh
// module chunks = 1